import { GridColDef } from '@material-ui/data-grid';

export const ColumnCodigoHistorico: GridColDef = {
  headerName: 'Código',
  field: 'codigo_historico',
  width: 200,
};

export const ColumnDescricaoHistorico: GridColDef = {
  headerName: 'Descrição',
  field: 'descricao_historico',
  width: 600,
};

export const ColumnId: GridColDef = {
  headerName: '#',
  field: 'id',
  hide: true,
  width: 400,
  editable: false,
  filterable: false,
  hideSortIcons: true,
  sortable: false,
  disableColumnMenu: true,
};
